module.exports = __webpack_public_path__ + "static/media/Xiangling.1169862f.png";